import create from "zustand";
import { getNotesArray } from "../features/notes/NoteFunctions";
import produce from "immer";

const useCurrentAccountStore = create((set) => ({
	account: {},
	buyer: {},
	coBuyer: {},
	vehicle: {},
	county: {},
	lease: {},
	amortizations: [],
	payments: [],
	pickupPmts: [],
	adjustments: [],
	lateFees: [],
	buyerAddress: {},
	buyerMailAddress: {},
	coBuyerAddress: {},
	coBuyerMailAddress: {},
	isLoading: true,
	salesPerson: {},
	lenders: [],
	salesPeople: [],
	lender: {},
	buyersInsuranceInfo: {},
	autoPays: [],
	digitzsPayments: [],
	editAutoPayStatusAtIndex: (index, value) =>
		set(
			produce((state) => {
				state.autoPays[index].active = value;
			})
		),
	editBuyerRecNum: (e) =>
		set(
			produce((state) => {
				state.account.buyerRecNum = e;
			})
		),

	editCoBuyerRecNum: (e) =>
		set(
			produce((state) => {
				state.account.coBuyerRecNum = e;
			})
		),
	editAccount: (obj) => set(() => ({ account: obj })),
	editBuyer: (obj) => set(() => ({ buyer: obj })),
	editCoBuyer: (obj) => set(() => ({ coBuyer: obj })),
	editVehicle: (obj) => set(() => ({ vehicle: obj })),
	editCounty: (obj) => set(() => ({ county: obj })),
	editLease: (obj) => set(() => ({ lease: obj })),
	editAdjustments: (list) => set(() => ({ adjustments: list })),
	editLateFees: (list) => set(() => ({ lateFees: list })),

	editAmortizations: (list) => set(() => ({ amortizations: list })),
	editPayments: (list) => set(() => ({ payments: list })),
	editPickupPmts: (list) => set(() => ({ pickupPmts: list })),
	editLenders: (list) => set(() => ({ lenders: list })),
	editLender: (obj) => set(() => ({ lender: obj })),
	editBuyerAddress: (obj) => set(() => ({ buyerAddress: obj })),
	editBuyerMailAddress: (obj) => set(() => ({ buyerMailAddress: obj })),
	editBuyerInsuranceInfo: (obj) => set(() => ({ buyersInsuranceInfo: obj })),
	editCoBuyerAddress: (obj) => set(() => ({ coBuyerAddress: obj })),
	editCoBuyerMailAddress: (obj) => set(() => ({ coBuyerMailAddress: obj })),
	editIsLoading: (e) => set(() => ({ isLoading: e })),
	editContractInfo: (obj) => set(() => ({ contractInfo: obj })),
	editSalesPerson: (obj) => set(() => ({ salesPerson: obj })),
	editInsuranceValue: (key, val) =>
		set((state) => ({
			buyersInsuranceInfo: {
				...state.buyersInsuranceInfo,
				[key]: val,
			},
		})),

	editAccountNotes: (e) =>
		set(
			produce((state) => {
				state.account.notes = e;
			})
		),

	setAccountFields: (res) => {
		set(() => ({
			...res,
			account: {
				...res.account,
				notes: getNotesArray(res.account.notes),
			},
		}));
	},
	editAutoPays: (list) => set(() => ({ autoPays: list })),
	reset: () => {
		set(() => ({
			account: {},
			buyer: {},
			coBuyer: {},
			vehicle: {},
			county: {},
			lease: {},
			amortizations: [],
			adjustments: [],
			lateFees: [],
			payments: [],
			pickupPmts: [],
			buyerAddress: {},
			buyerMailAddress: {},
			coBuyerAddress: {},
			coBuyerMailAddress: {},
			isLoading: true,
			salesPerson: {},
			lenders: [],
			salesPeople: [],
			lender: {},
		}));
	},
}));

export default useCurrentAccountStore;
